<div class="panel" [ngClass]="{ 'panel-bordered': border, 'panel-compact': compact }">
  <span *ngIf="title" class="label">{{ title }}</span>
  
  <ion-input
    class="input" 
    [ngClass]="{ 'input-full': !compact, 'input-compact': compact }"
    mode="ios"
    type="decimal" 
    inputmode="decimal"
    [maxlength]="3"
    [minlength]="1"
    [value]="value"
    (ionInput)="onInput($event)"
    (ionChange)="onChange($event)"
    placeholder=""
    [disabled]="disabled"
  >
    <span 
      *ngIf="showTempLabel"
      class="type"
      [ngClass]="{ 'type-gap': type === tempType }"
      slot="end" 
      aria-hidden="true"
    >{{ type }}</span>
  </ion-input>
</div>
